import React from 'react';
import { AwardIcon, SprayCanIcon, BadgeCheckIcon, TimerIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import type { ValueIcon } from '../data/content';
const icons: Record<ValueIcon, React.ComponentType<{
  className?: string;
}>> = {
  medal: AwardIcon,
  spray: SprayCanIcon,
  check: BadgeCheckIcon,
  clock: TimerIcon
};
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  return <section className="bg-mist py-20 sm:py-24" data-id="element-421" data-mp="l6fylodip9sn">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-422" data-mp="l8aiczd1yvv5">
        <SectionHeading kicker={t.why.kicker} title={t.why.title} data-id="element-423" data-mp="77pz62386y14" />

        <div className="mt-12 grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-424" data-mp="b8jn2vgo4cu0">
          {t.why.items.map(item => {
          const Icon = icons[item.icon];
          return <div key={item.title} className="flex flex-col" data-id="element-425" data-mp="21j4s0rrj9dl3">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-brand-blue/10 text-brand-blue" data-id="element-426" data-mp="25l9f17nh7byr">
                  <Icon className="h-6 w-6" data-id="element-427" data-mp="1nckb3wusla6q" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-navy" data-id="element-428" data-mp="1iesj72u5do2j">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-429" data-mp="1x3f0vb78yrwx">{item.description}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}